import { useState } from 'react'
import { Tooltip } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { WarningAmber, StickyNote2, EditNote } from '@mui/icons-material'
import { DiagnosticsSummary } from '../types/models'
import { DiagnosticsDialog } from './DiagnosticsDialog'

interface DiagnosticsIndicatorProps {
  diagnostics: DiagnosticsSummary | null | undefined
  userId: number
  userEmail: string
}

export function DiagnosticsIndicator({ diagnostics, userId, userEmail }: DiagnosticsIndicatorProps) {
  const { t } = useTranslation()
  const [dialogOpen, setDialogOpen] = useState(false)

  const hasIssues = diagnostics && (diagnostics.warnings > 0 || diagnostics.errors > 0)
  const hasComments = diagnostics?.has_comments
  const hasErrors = diagnostics && diagnostics.errors > 0

  let icon
  let tooltip

  if (hasIssues) {
    const total = (diagnostics?.warnings || 0) + (diagnostics?.errors || 0)
    tooltip = t('Diag-issues-tooltip', { count: total })
    icon = (
      <WarningAmber
        sx={{
          color: hasErrors ? '#f44336' : '#ffa726',
          fontSize: '1.1rem',
          cursor: 'pointer',
          '&:hover': { opacity: 0.7 }
        }}
      />
    )
  } else if (hasComments) {
    tooltip = t('Diag-has-comments')
    icon = (
      <StickyNote2
        sx={{
          color: '#90caf9',
          fontSize: '1rem',
          cursor: 'pointer',
          '&:hover': { opacity: 0.7 }
        }}
      />
    )
  } else {
    tooltip = t('Diag-add-comment')
    icon = (
      <EditNote
        sx={{
          color: '#616161',
          fontSize: '1rem',
          cursor: 'pointer',
          '&:hover': { color: '#9e9e9e' }
        }}
      />
    )
  }

  return (
    <>
      <Tooltip title={tooltip} arrow>
        <span
          onClick={(e) => { e.stopPropagation(); setDialogOpen(true) }}
          style={{ display: 'inline-flex', alignItems: 'center' }}
        >
          {icon}
        </span>
      </Tooltip>
      {dialogOpen && (
        <DiagnosticsDialog
          open={dialogOpen}
          onClose={() => setDialogOpen(false)}
          userId={userId}
          userEmail={userEmail}
        />
      )}
    </>
  )
}
